import { Trans } from '@lingui/react/macro';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@repo/videa-components/src/ui/dialog';

import { PatientEducationContent } from './PatientEducationContent';

type PatientEducationDialogProps = {
  imageId?: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const PatientEducationDialog = ({
  imageId,
  isOpen,
  setIsOpen,
}: PatientEducationDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        data-testid="patient-education-dialog"
        className="vai-bg-background-dark vai-text-foreground-dark vai-max-w-[1024px] vai-max-h-[90vh] vai-overflow-y-auto vai-overflow-x-hidden"
      >
        <DialogTitle className="vai-font-inter vai-font-semibold vai-text-xl vai-w-full vai-max-w-full vai-min-w-0">
          <Trans>Patient Education</Trans>
        </DialogTitle>
        <div className="vai-w-full vai-max-w-full vai-min-w-0 vai-overflow-hidden">
          <PatientEducationContent imageId={imageId} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
